module.exports = __webpack_public_path__ + "media/images/bg-O-03a86ed7c73b468c246f24b0b01299e3.svg";